var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrosIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 276.667,
    height: 238.506,
    viewBox: "0 0 276.667 238.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_497"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffbb69",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_497-2",
    "data-name": "Trac\\xE9 497",
    d: "M981.076,923.721l-100.708-163.6a37.366,37.366,0,0,0-63.879-.3L716.009,923.074A35.852,35.852,0,0,0,710,943.2a37.407,37.407,0,0,0,37.435,37.3h201.8a37.407,37.407,0,0,0,37.435-37.3,35.205,35.205,0,0,0-5.591-19.481ZM848.333,942.345a19.08,19.08,0,1,1,19.081-19.08,19.087,19.087,0,0,1-19.081,19.08Zm19.081-66.782a19.081,19.081,0,0,1-38.161,0V837.4a19.081,19.081,0,0,1,38.161,0Zm0,0",
    transform: "translate(-710 -742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_497-3",
    "data-name": "Trac\\xE9 497",
    d: "M981.076,923.721l-100.708-163.6a37.366,37.366,0,0,0-63.879-.3L716.009,923.074A35.852,35.852,0,0,0,710,943.2a37.407,37.407,0,0,0,37.435,37.3h201.8a37.407,37.407,0,0,0,37.435-37.3,35.205,35.205,0,0,0-5.591-19.481ZM848.333,942.345a19.08,19.08,0,1,1,19.081-19.08,19.087,19.087,0,0,1-19.081,19.08Zm19.081-66.782a19.081,19.081,0,0,1-38.161,0V837.4a19.081,19.081,0,0,1,38.161,0Zm0,0",
    transform: "translate(-710 -742)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrosIcons);
export default __webpack_public_path__ + "static/media/erros-icons.64778cdb48bcd98b75fd581f4d01a5df.svg";
export { ForwardRef as ReactComponent };